module.exports = __webpack_public_path__ + "static/media/loading.f4404720.gif";